/**
 * Rakhi Gift Box Add-on Checkbox
 * ------------------------------------------------------------------
 * Loaded sitewide via layout/theme.liquid (defer), right after
 * cart-gift-progress-bar.js.
 *
 * Renders from snippets/rakhi-addon-checkbox.liquid, included in
 * snippets/product-form.liquid just below the Add to Cart / Buy Now
 * buttons.
 *
 * BEHAVIOUR: the checkbox itself controls whether the add-on is in the
 * cart -- checking it adds it immediately, unchecking removes it
 * immediately. This is independent of the product form's own Add to
 * Cart submission entirely (checking the box works whether the main
 * product has already been added, is added afterward, or never is).
 *
 * Since the add-on has a single variant with no custom properties,
 * Shopify merges repeated adds into one line automatically, so
 * "checked" cleanly means "this variant is present in the cart" with
 * quantity 1, regardless of which product page the box was checked on.
 *
 * On page load, the checkbox's state is synced to the real cart (via
 * /cart.js) so it reflects reality if the add-on is already in the
 * cart from another page.
 *
 * After every add/remove, this reuses the SAME drawer-refresh mechanism
 * already in cart-gift-progress-bar.js (exposed there as
 * window.WriteHouseCartSync.refresh) instead of re-implementing that
 * logic here.
 */
(function () {
  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) {
      return res.json();
    });
  }

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function addAddon(variantId) {
    return postCart('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
  }

  function removeAddon(variantId) {
    return postCart('/cart/change.js', { id: String(variantId), quantity: 0 });
  }

  function refreshCartSync() {
    if (window.WriteHouseCartSync && typeof window.WriteHouseCartSync.refresh === 'function') {
      window.WriteHouseCartSync.refresh();
    }
  }

  function onChange(e) {
    var checkbox = e.target;
    if (!checkbox || !checkbox.matches || !checkbox.matches('[data-rakhi-addon-checkbox]')) return;

    var variantId = parseInt(checkbox.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    checkbox.disabled = true;
    var action = checkbox.checked ? addAddon(variantId) : removeAddon(variantId);
    action
      .then(refreshCartSync)
      .catch(function () {})
      .then(function () {
        checkbox.disabled = false;
      });
  }

  function syncCheckboxState() {
    var checkboxes = document.querySelectorAll('[data-rakhi-addon-checkbox]');
    if (!checkboxes.length) return;

    fetchCart().then(function (cart) {
      checkboxes.forEach(function (checkbox) {
        var variantId = parseInt(checkbox.getAttribute('data-variant-id'), 10);
        if (!variantId) return;
        checkbox.checked = cart.items.some(function (item) {
          return item.variant_id === variantId;
        });
      });
    });
  }

  document.addEventListener('change', onChange, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCheckboxState);
  } else {
    syncCheckboxState();
  }
})();
